module.exports = __webpack_public_path__ + "static/cartabsFrontLayout1-64e2d978decb17e40032189df4f8e8f2.png";